import { required } from "../../shared/src/codecs/types/required";
import { uuid } from "../../shared/src/codecs/types/uuid";
import { string } from "../../shared/src/codecs/types/string";
import { TTypeOfCodec } from "../../shared/src/codecs/codec";

export const GuideRead = required({
    id: uuid(),
    user_id: uuid(),
    product: string(),
    slug: string(),
    content_hash: string(),
    read_at: string(),
});

export type TGuideRead = TTypeOfCodec<typeof GuideRead>;

export const PostGuideReadBody = required({
    product: string(),
    slug: string(),
    content_hash: string(),
});

export type TPostGuideReadBody = TTypeOfCodec<typeof PostGuideReadBody>;
